class Logger {
  // chalk was dropped from this browser bundle (2026-07 JS audit): it detects
  // non-terminal environments and returned the strings unstyled anyway, at a
  // cost of ~5KB. These formatters keep the API shape.
  styles = {
    variant: (s) => s,
    product: (s) => s,
    code: (s) => s,
    tag: (s) => s,
    properties: (s) => s
  };

  constructor() {

  }

  variant(variant) {
    return `Variant ${this.styles.variant(` ${variant.title || "Unknown Title"} (${variant.id}) `)}`
  }

  product(product) {
    return `Product ${this.styles.product(` ${product.title || "Unknown Title"} (${product.id || "Unknown ID"}) `)}`
  }

  code(code) {
    return `Discount Code ${this.styles.code(` ${code} `)}`
  }

  tag(tag) {
    return `Tag ${this.styles.tag(` [${tag}] `)}`
  }

  properties(properties) {
    return `Properties ${this.styles.properties(`${JSON.stringify(properties)}`)}`
  }
}

export default Logger;